import React from 'react';
import { Chip } from '@material-ui/core';
import { paymentStatus } from '@crm/utils';

/**
 * Interface pour les props du composant PaymentStatusBadge
 */
interface PaymentStatusBadgeProps {
  payment: CRM.ReservationPayment;
}

const badges: Record<CRM.ReservationPaiementStatus, React.ReactElement> = {
  paid: (
    <Chip
      size="medium"
      label="PAYÉE"
      //title="PAYÉE"
      color="secondary"
      className={'bold bgGreen'}
      style={{fontSize: '0.9rem'}}
    />
  ),
  unpaid: (
    <Chip
      size="medium"
      label="NON PAYÉE"
      //title="NON PAYÉE"
      color="secondary"
      className={'bold bgRed'}
      style={{fontSize: '0.9rem'}}
    />
  ),
  failed: (
    <Chip
      size="medium"
      label="ECHEC"
      //title="ECHEC"
      color="secondary"
      className={'bold bgYellow'}
      style={{fontSize: '0.9rem'}}
    />
  ),
  needRefund: (
    <Chip
      size="medium"
      label="A REMBOURSER"
      //title="A REMBOURSER"
      color="secondary"
      className={'bold bgOrange'}
      style={{fontSize: '0.9rem'}}
    />
  ),
  partialRefund: (
    <Chip
      size="medium"
      label="REMB. PARTIEL"
      //title="REMB. PARTIEL"
      color="secondary"
      className={'bold bgYellow'}
      style={{fontSize: '0.9rem'}}
    />
  ),
  refunded: (
    <Chip
      size="medium"
      label="REMBOURSÉE"
      //title="REMBOURSÉE"
      color="secondary"
      className={'bold bgGreen'}
      style={{fontSize: '0.9rem'}}
    />
  ),
  partial: (
    <Chip
      size="medium"
      label="ACOMPTE"
      //title="ACOMPTE"
      color="secondary"
      className={'bold bgOrange'}
      style={{fontSize: '0.9rem'}}
    />
  ),
  waitToPaid: (
    <Chip
      size="medium"
      label="PAIEMENT EN ATTENTE"
      //title="PAIEMENT EN ATTENTE"
      color="secondary"
      className={'bold bgOrange'}
      style={{fontSize: '0.9rem'}}
    />
  ),
};

/**
 * Composant d'affichage du statut de paiement d'une réservation
 * 
 * Ce composant affiche visuellement le statut de paiement avec :
 * - Chips colorés selon le statut (vert, rouge, orange, jaune)
 * - Labels explicites pour chaque statut
 * - Styles cohérents avec la charte graphique
 * 
 * Statuts supportés :
 * - paid: PAYÉE (vert)
 * - unpaid: NON PAYÉE (rouge)
 * - failed: ECHEC (jaune)
 * - needRefund: A REMBOURSER (orange)
 * - partialRefund: REMB. PARTIEL (jaune)
 * - refunded: REMBOURSÉE (vert)
 * - partial: ACOMPTE (orange)
 * - waitToPaid: PAIEMENT EN ATTENTE (orange)
 * 
 * Logique métier :
 * - Utilise la fonction paymentStatus de @crm/utils pour déterminer le statut
 * - Mapping visuel cohérent des statuts avec des couleurs intuitives
 * - Support de tous les statuts de paiement du système
 * 
 * @param payment Objet de paiement de la réservation
 * @returns Composant React affichant le statut de paiement
 */
export function PaymentStatusBadge({ payment }: PaymentStatusBadgeProps) {
  const status = paymentStatus(payment, true);
  return badges[status];
}
